module.exports = __webpack_public_path__ + "img/celebrate.f386e2d2.svg";